/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useEffect, useState } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import BlotFormatter from 'quill-blot-formatter';
import {
  Button,
  FormGroup,
  InputGroup,
  Card,
  CardBody,
  Form,
  InputGroupAddon,
  InputGroupText,
  Input,
  Row,
  Col,
  Container,
} from 'reactstrap';
import api from 'services/api';
import Header from 'components/Headers/Header.js';
import { PropostaVersao } from 'models/PropostaVersao';
import Proposta from 'models/Proposta';
import { PropostaMeioPagamento } from 'models/PropostaMeioPagamento';
import { PropostaConfiguracao } from 'models/PropostaConfiguracao';
import { ProdutoProposta } from 'models/ProdutoProposta';
import Parametros from 'models/Parametros';
import { useQueries, useQuery } from 'react-query';
import OrcamentoProduto from 'models/OrcamentoProduto';
import FichaTecnica from 'models/FichaTecnica';
import BancoFinanciamento from 'models/BancoFinanciamento';
import ImpressaoPagamento from 'views/components/ImpressaoPagamento';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import {
  ColQuestao,
  DivSub,
  InputAta,
  LabelItem,
  LabelTema,
  Labelcabecalho,
  SpanTitulo,
  TituloDestaque,
  Geral,
  CabecalhoFixoAta,
  TituloAta,
  TemaAta,
  CabecalhoEditAta,
  ColunaDados,
  ConteudoDocumentoAta,
  DivFormatada,
} from './style';
import AtaModel from '../../../models/AtaBriefing';
import LancesBalanco from '../ConfiguracaoEtapas/components/Resultado/components/organisms/DadosCalculados/components/LancesBalanco';
import './styles.css';
import 'react-quill/dist/quill.snow.css';
import Resultados from '../Proposta/components/Resultados';

interface LocationState {
  proposta: Proposta;
  propostaVersao: PropostaVersao;
  meioPagamentos: PropostaMeioPagamento[];
  meioPagamentoIdSelecionado: number;
  propostaConfiguracao: PropostaConfiguracao;
  produtoProposta: ProdutoProposta;
}

interface IndicadorAtaItem {
  id?: number;
  papel: string;
  pessoa: string;
  codigo?: number;
  nivel?: string;
  ordem?: number;
}

interface PapeisAtaSetor {
  setor: string;
  descricaoSetor?: string | null;
  indicadores: IndicadorAtaItem[];
}

type PapeisAta = PapeisAtaSetor | IndicadorAtaItem;
const AtaProposta: React.FC = () => {
  const location = useLocation<LocationState>();

  const [orcamentoProduto, setOrcamentoProduto] = useState<OrcamentoProduto>();
  const {
    proposta,
    propostaVersao,
    meioPagamentos,
    meioPagamentoIdSelecionado,
  } = location.state;
  const orcamentoId = propostaVersao.PropostaConfiguracao?.[0].orcamentoId;
  const propData = propostaVersao.dataProposta;
  const {
    nome: descricaoProduto,
    nomeProposta,
    regramentoProposta,
  } = orcamentoProduto?.produto || {};
  const isRegramentoGeral = !(regramentoProposta ?? false);
  const [isSaving, setIsSaving] = useState(false);
  const [ataBriefingEditing, setAtaBriefingEditing] = useState({} as AtaModel);
  const [papeisAta, setPapeisAta] = useState([] as PapeisAta[]);
  const [validadeProposta, setValidadeProposta] = useState(0);
  const [texto, setTexto] = useState('');
  const [acessoLimitadoAta, setAcessoLimitadoAta] = useState(false);

  const [bancosFinanciamento, setBancoFinanciamento] = useState<
    BancoFinanciamento[]
  >([]);

  const meioSelecionado = meioPagamentos.filter(
    meioPagamento => meioPagamento.id === meioPagamentoIdSelecionado,
  );

  const [isLoadingContent, setIsLoadingContent] = useState(false);
  const isFinanciados = meioPagamentos.find(
    meioPagamento => meioPagamento.id === meioPagamentoIdSelecionado,
  )?.financiado;
  // const formats = ['align', 'float'];
  Quill.register('modules/blotFormatter', BlotFormatter);

  async function listaDadosAta() {
    if (propostaVersao.id) {
      const response = await api.get(
        `/ata-briefing/lista-por-proposta/${propostaVersao.id}`,
      );

      setAtaBriefingEditing(response.data);
      setTexto(response.data.documento);
    }
  }

  async function getAcessoLimitadoAta() {
    const response = await api.get('/acesso-programa/acesso-limitado', {
      params: {
        programaId: 86,
      },
    });

    const retorno = response.data;

    setAcessoLimitadoAta(retorno);
  }

  useEffect(() => {
    getAcessoLimitadoAta();
  }, []);

  async function listaDadosEditor() {
    if (ataBriefingEditing.id) {
      const response = await api.get(
        `/ata-briefing/conteudo-documento/${ataBriefingEditing.id}`,
      );

      setTexto(response.data.documento);
    }
  }

  async function listaPapeisAta() {
    if (propostaVersao.id) {
      const response = await api.post(
        `/integracao/niveis-indicadores/tipos-indicadores-ata/`,
        {
          propostaVersaoId: propostaVersao.id,
        },
      );

      setPapeisAta(response.data);
    }
  }

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
  }, []);

  useEffect(() => {
    listaDadosAta();
    listaDadosEditor();
    listaPapeisAta();
    // buscaDadosCliente();
  }, []);

  const { data: queryParametros, isLoading } = useQuery(
    `parametros`,
    async () => {
      async function getData(): Promise<Parametros> {
        const response = await api.get('/parametros');
        return response.data;
      }

      const dataParametros = await getData();
      return dataParametros;
    },
  );

  useEffect(() => {
    if (queryParametros) {
      setValidadeProposta(queryParametros.validadeProposta ?? 0);
    }
  }, [queryParametros]);

  const fichaTecnicaQueries = useQueries(
    propostaVersao.PropostaConfiguracao?.map(item => ({
      queryKey: ['ficha-tecnica-orcamento', item.orcamentoId],
      queryFn: async () => {
        if (item.orcamentoId) {
          const response = await api.get(
            `/ficha-tecnica/orcamento-versao/novo/${item.orcamentoId}`,
          );
          return response.data;
        }
        return null;
      },
      enabled: !!item.orcamentoId,
    })) || [],
  );

  const { data: cacheOrcamentoProduto } = useQuery(
    `configuracao-${orcamentoId}-produto`,
    async () => {
      if (orcamentoId) {
        const response = await api.get(`/orcamento/versao/${orcamentoId}`, {
          params: { completo: true },
        });
        const orcamentoProdutoData: OrcamentoProduto =
          response.data.OrcamentoProduto[0];
        return orcamentoProdutoData;
      }
      return false;
    },
  );

  useEffect(() => {
    if (cacheOrcamentoProduto) {
      setOrcamentoProduto(cacheOrcamentoProduto);
    }
  }, [cacheOrcamentoProduto]);

  const { data: queryBancos } = useQuery(
    `banco-financiamento`,
    async () => {
      // const response = await api.get(`/integracao/banco`);
      const response = await api.get(`/proposta-banco/`);
      return response.data;
    },
    { staleTime: Infinity },
  );

  useEffect(() => {
    if (queryBancos) {
      setBancoFinanciamento(queryBancos);
    }
  }, [queryBancos]);

  function formataMoeda(valor?: number | null) {
    if (valor === null || valor === undefined) {
      return '';
    }
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valor || 0);
  }

  async function handleSave() {
    // eslint-disable-next-line prettier/prettier
    const { id } = ataBriefingEditing;

    if (!propostaVersao.id) {
      toast.error(
        'Todos os campos marcados com * são de preenchimento obrigatório!',
      );
      return;
    }
    setIsSaving(true);

    if (ataBriefingEditing.id) {
      await api.put(`/ata-briefing/${ataBriefingEditing.id}`, {
        propostaVersaoId: propostaVersao.id,
        documento: texto,
        dataInicio: ataBriefingEditing.dataInicio,
        dataFim: ataBriefingEditing.dataFim,
        local: ataBriefingEditing.local,
        horario: ataBriefingEditing.horario,
        participantes: ataBriefingEditing.participantes,
        comCopia: ataBriefingEditing.comCopia,
        supervisorComercial: ataBriefingEditing.supervisorComercial,
        executivoVendas: ataBriefingEditing.executivoVendas,
        representanteGestor: ataBriefingEditing.representanteGestor,
        analiseNegocio: ataBriefingEditing.analiseNegocio,
        nomeCliente: ataBriefingEditing.nomeCliente,
        briefingClienteObra: ataBriefingEditing.briefingClienteObra,
        formaPagamento: ataBriefingEditing.formaPagamento,
        propostaCliente: ataBriefingEditing.propostaCliente,
        cronograma: ataBriefingEditing.cronograma,
        briefingConcorrentes: ataBriefingEditing.briefingConcorrentes,
        propostaFockinkCliente: ataBriefingEditing.propostaFockinkCliente,
        cronogramaFockink: ataBriefingEditing.cronogramaFockink,
        observacao: ataBriefingEditing.observacao,
        definicao: ataBriefingEditing.definicao,
        tema: ataBriefingEditing.tema,
        indicador: ataBriefingEditing.indicador,
      });
    }

    toast.success('Registro concluído');
    setIsSaving(false);
    setAtaBriefingEditing({} as AtaModel);
    listaDadosAta();
    listaDadosEditor();
  }

  useEffect(() => {
    if (isLoadingContent === true)
      toast.loading('Carregando conteúdo...', { position: 'top-right' });
    else toast.dismiss();
  }, [isLoadingContent]);

  const dataFormatadaAta = propData
    ? new Intl.DateTimeFormat('pt-BR').format(new Date(propData))
    : null;
  const bancoSelecionado = bancosFinanciamento?.filter(
    item => item.codigo === propostaVersao.bancoProposta,
  );

  const nomeBanco = bancoSelecionado[0]?.razaoSocial;

  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote', 'code-block'],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    [{ direction: 'rtl' }], // text direction

    [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],

    ['clean'], // remove formatting button
  ];

  // eslint-disable-next-line no-console

  function createMarkup(tipo: string) {
    if (tipo === 'indicador')
      return { __html: `${ataBriefingEditing.indicador ?? ''}` };

    return { __html: `${ataBriefingEditing.documento ?? ''}` };
  }

  return (
    <>
      <Header showCards={false} />
      <Container className="mt--7" fluid>
        <Card className="shadow">
          <Form>
            <Row>
              <Col className="col">
                <CardBody>
                  <Geral>
                    <CabecalhoFixoAta>
                      <Row>
                        <Col sm="4">
                          Proposta:&nbsp;{proposta.id}&nbsp;
                          &nbsp;&nbsp;&nbsp;Versão: {propostaVersao.versao}
                        </Col>
                        <Col sm="8">
                          <span className="span-titulo">ATA DE REUNIÃO</span>
                        </Col>
                      </Row>
                    </CabecalhoFixoAta>
                    <TituloAta>
                      <TituloDestaque>
                        DOCUMENTO CONFIDENCIAL E DE CIRCULAÇÃO INTERNA –
                        VALIDADE DESTA ATA {validadeProposta} DIAS
                      </TituloDestaque>
                    </TituloAta>
                    <TemaAta>
                      <Row sm="12" md="12" xs="12">
                        <Col sm="2" className="mt-2 mb-2">
                          <LabelTema>TEMA:</LabelTema>
                        </Col>

                        <Col sm="10" className="mt-2 mb-2">
                          <InputGroup className="input-group-alternative invalid-feedback">
                            <InputAta
                              className="input-group-alternative"
                              type="text"
                              value={ataBriefingEditing.tema}
                              disabled={propostaVersao.status.id === 3}
                              onChange={text =>
                                setAtaBriefingEditing({
                                  ...ataBriefingEditing,
                                  tema: text.target.value,
                                })
                              }
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                    </TemaAta>

                    <CabecalhoEditAta>
                      <Row sm="4" md="4" xs="12">
                        <ColunaDados sm="4" md="4">
                          <Row className="p-2 mt-1 ml-1">
                            <ColQuestao>
                              <Labelcabecalho>Data:&nbsp;</Labelcabecalho>{' '}
                            </ColQuestao>
                            <Col>
                              <InputGroup className="input-group-alternative invalid-feedback">
                                <InputAta
                                  className="input-group-alternative"
                                  type="text"
                                  value={
                                    ataBriefingEditing.dataInicio
                                      ? String(dataFormatadaAta)
                                      : String(
                                          new Intl.DateTimeFormat(
                                            'pt-BR',
                                          ).format(new Date()),
                                        )
                                  }
                                  disabled
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="p-2 mt-1 ml-1">
                            <ColQuestao>
                              <Labelcabecalho>Horário:&nbsp;</Labelcabecalho>
                            </ColQuestao>
                            <Col>
                              <InputGroup className="input-group-alternative invalid-feedback">
                                <InputAta
                                  className="input-group-alternative"
                                  type="textarea"
                                  value={ataBriefingEditing.horario}
                                  disabled={propostaVersao.status.id === 3}
                                  onChange={text =>
                                    setAtaBriefingEditing({
                                      ...ataBriefingEditing,
                                      horario: text.target.value,
                                    })
                                  }
                                />
                              </InputGroup>
                            </Col>
                          </Row>
                          <Row className="p-2 mt-1 ml-1">
                            <ColQuestao>
                              <Labelcabecalho>Local:&nbsp;</Labelcabecalho>
                            </ColQuestao>
                            <Col>
                              <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                      <i
                                        className="ni ni-align-center"
                                        style={{
                                          alignSelf: 'start',
                                          marginTop: '0.3rem',
                                        }}
                                      />
                                    </InputGroupText>
                                  </InputGroupAddon>

                                  <Input
                                    placeholder="Local:"
                                    rows="3"
                                    type="textarea"
                                    value={ataBriefingEditing.local}
                                    disabled={propostaVersao.status.id === 3}
                                    onChange={text =>
                                      setAtaBriefingEditing({
                                        ...ataBriefingEditing,
                                        local: text.target.value,
                                      })
                                    }
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                        </ColunaDados>
                        <ColunaDados sm="4" md="4">
                          <Row className="p-2 mt-1 ml-1">
                            <ColQuestao>
                              <Labelcabecalho>
                                Participantes:&nbsp;
                              </Labelcabecalho>
                            </ColQuestao>
                            <Col>
                              <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                      <i
                                        className="ni ni-align-center"
                                        style={{
                                          alignSelf: 'start',
                                          marginTop: '0.3rem',
                                        }}
                                      />
                                    </InputGroupText>
                                  </InputGroupAddon>

                                  <Input
                                    placeholder="Participantes:"
                                    rows="6"
                                    type="textarea"
                                    value={ataBriefingEditing.participantes}
                                    disabled={propostaVersao.status.id === 3}
                                    onChange={text =>
                                      setAtaBriefingEditing({
                                        ...ataBriefingEditing,
                                        participantes: text.target.value,
                                      })
                                    }
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                        </ColunaDados>
                        <ColunaDados sm="4" md="4">
                          <Row className="p-2 mt-1 ml-1">
                            <ColQuestao>
                              <Labelcabecalho>C/C:&nbsp;</Labelcabecalho>
                            </ColQuestao>
                            <Col>
                              <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                      <i
                                        className="ni ni-align-center"
                                        style={{
                                          alignSelf: 'start',
                                          marginTop: '0.3rem',
                                        }}
                                      />
                                    </InputGroupText>
                                  </InputGroupAddon>

                                  <Input
                                    placeholder="C/C:"
                                    rows="6"
                                    type="textarea"
                                    value={ataBriefingEditing.comCopia}
                                    disabled={propostaVersao.status.id === 3}
                                    onChange={text =>
                                      setAtaBriefingEditing({
                                        ...ataBriefingEditing,
                                        comCopia: text.target.value,
                                      })
                                    }
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                        </ColunaDados>
                      </Row>
                    </CabecalhoEditAta>
                    <ConteudoDocumentoAta>
                      {/* }
                      <Row>
                        <Col>
                          <LabelQuestao>
                            Supervisor Comercial: &nbsp;
                          </LabelQuestao>
                          <SpanTitulo>
                            {ataBriefingEditing.supervisorComercial}
                          </SpanTitulo>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <LabelQuestao>
                            Executivo de Vendas: &nbsp;
                          </LabelQuestao>
                          <SpanTitulo>
                            {ataBriefingEditing.executivoVendas}
                          </SpanTitulo>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <LabelQuestao>
                            Representante/Gestor: &nbsp;
                          </LabelQuestao>
                          <SpanTitulo>
                            {ataBriefingEditing.representanteGestor ??
                              ownerProposta}
                          </SpanTitulo>
                        </Col>
                      </Row>
                            { */}
                      <div className="space-items mt-6">
                        {propostaVersao.statusId === 3 && (
                          <div
                            dangerouslySetInnerHTML={createMarkup('indicador')}
                          />
                        )}
                        {propostaVersao.statusId !== 3 && (
                          <Row className="space-items mt-3">
                            {papeisAta.map((item: any, idx: number) => {
                              if (item.indicadores) {
                                const labelSetor = `Setor de Atividade ${item.setor} - ${item.descricaoSetor}:`;
                                return (
                                  <Col
                                    sm="4"
                                    md="4"
                                    key={item.setor || idx}
                                    className="mb-4"
                                  >
                                    <Row className="mb-2">
                                      <Col>
                                        <LabelItem
                                          style={{
                                            fontWeight: 'bold',
                                          }}
                                        >
                                          {labelSetor}
                                        </LabelItem>
                                      </Col>
                                    </Row>
                                    {item.indicadores.map(
                                      (campo: any, cIdx: number) => (
                                        <React.Fragment key={cIdx}>
                                          <Row className="space-items mt-2">
                                            <Col>
                                              <LabelItem>
                                                {campo.papel}: &nbsp;
                                              </LabelItem>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col>
                                              <SpanTitulo>
                                                {campo.pessoa}
                                              </SpanTitulo>
                                            </Col>
                                          </Row>
                                        </React.Fragment>
                                      ),
                                    )}
                                  </Col>
                                );
                              }

                              return (
                                <Col sm="4" md="4" key={idx} className="mb-4">
                                  <Row className="space-items mt-2">
                                    <Col>
                                      <LabelItem>
                                        {item.papel}: &nbsp;
                                      </LabelItem>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <SpanTitulo>{item.pessoa}</SpanTitulo>
                                    </Col>
                                  </Row>
                                </Col>
                              );
                            })}
                          </Row>
                        )}
                      </div>
                      <div className="space-items mt-6">
                        <Row>
                          <Col>
                            <LabelItem>Nome do Cliente: &nbsp;</LabelItem>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <SpanTitulo>
                              {proposta.pessoa?.razaoSocial}
                            </SpanTitulo>
                          </Col>
                        </Row>
                      </div>
                      <div className="space-items mt-3">
                        <Row>
                          <Col sm="2">
                            <LabelItem>Cidade:&nbsp;</LabelItem>
                          </Col>
                          <Col sm="2">
                            <LabelItem>Estado:&nbsp;</LabelItem>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="2">
                            <SpanTitulo>
                              {proposta.PropostaLocalObra?.municipio}
                            </SpanTitulo>
                          </Col>
                          <Col sm="2">
                            <SpanTitulo>
                              {proposta.PropostaLocalObra?.uf}
                            </SpanTitulo>
                          </Col>
                        </Row>
                      </div>
                      <div className="space-items mt-3">
                        <Row>
                          <Col sm="2">
                            <LabelItem>Forma de pagamento:&nbsp;</LabelItem>
                          </Col>
                          {isFinanciados && (
                            <>
                              <Col sm="2">
                                <LabelItem>Banco:&nbsp;</LabelItem>
                              </Col>
                              <Col sm="2">
                                <LabelItem>Formato:&nbsp;</LabelItem>
                              </Col>
                              <Col sm="2">
                                <LabelItem>Linha de Crédito:&nbsp;</LabelItem>
                              </Col>
                            </>
                          )}
                        </Row>
                        <Row>
                          <Col sm="2">
                            <SpanTitulo>
                              {meioSelecionado?.[0]?.descricao ?? ''}
                            </SpanTitulo>
                          </Col>
                          {isFinanciados && (
                            <>
                              <Col sm="2">
                                <SpanTitulo>{nomeBanco}</SpanTitulo>
                              </Col>
                              <Col sm="2">
                                <SpanTitulo>
                                  {propostaVersao?.formatoBanco}
                                </SpanTitulo>
                              </Col>
                              <Col sm="2">
                                <SpanTitulo>
                                  {propostaVersao?.PropostaLinhaCredito?.nome}
                                </SpanTitulo>
                              </Col>
                            </>
                          )}
                        </Row>
                      </div>
                      {propostaVersao.PropostaConfiguracao?.map(
                        (item, index) => {
                          const { data: ftUsar } =
                            fichaTecnicaQueries[index] || {};

                          const marca = 'Marca Fockink';

                          const incluirAspersorFinal =
                            ftUsar?.incluirAspersorFinal;
                          const areaTotalIrrigadaCAF =
                            ftUsar?.areaTotalIrrigadaCAF;
                          const areaEfetivaIrrigadaSAF =
                            ftUsar?.areaEfetivaIrrigadaSAF;
                          const usaAspersorFinal: boolean =
                            String(incluirAspersorFinal).toUpperCase() ===
                              'SIM' ||
                            String(incluirAspersorFinal).toUpperCase() === 'S';

                          const valorArea = usaAspersorFinal
                            ? Number(areaTotalIrrigadaCAF ?? 0)
                            : Number(areaEfetivaIrrigadaSAF ?? 0);

                          const sist =
                            ftUsar?.FichaTecnicaBombeamento?.[0]?.motor ||
                            'NÃO INFORMADO';
                          const qtdeLances = ftUsar?.FichaTecnicaLance?.reduce(
                            (total: any, aux: { quantidade: any }) =>
                              total + aux.quantidade,
                            0,
                          );
                          const r1 = Number(ftUsar?.aspersor1Raio ?? 0);
                          const r2 = Number(ftUsar?.aspersor2Raio ?? 0);
                          const txtUsar = `${
                            nomeProposta ?? descricaoProduto
                          }, ${marca}, sendo ${sist} com
                            ${qtdeLances} torres de sustentação, raio
                            ${
                              Number(ftUsar?.comprimentoTotalTubos ?? 0) +
                              (r1 > r2 ? r1 : r2)
                            }M para área irrigada de ${valorArea} HA, composto de:`;

                          const titulo = `Configuração: ${
                            item?.orcamentoId ?? 'Não especificado'
                          } ${
                            ftUsar?.pivoCentral
                              ? ` | Equipamento ${ftUsar?.pivoCentral}`
                              : ''
                          }`;
                          return (
                            <div
                              key={item.orcamentoId}
                              className="space-items mt-3"
                              hidden={isRegramentoGeral}
                            >
                              <Row>
                                <Col>
                                  <h2>
                                    <SpanTitulo>{titulo}</SpanTitulo>
                                  </h2>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <LabelItem>
                                    Proposta Fockink ao cliente:&nbsp;
                                  </LabelItem>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  {/* <SpanTitulo>{textoProduto}</SpanTitulo> */}
                                  <SpanTitulo>{txtUsar}</SpanTitulo>
                                </Col>
                              </Row>
                              <Row>
                                {ftUsar && (
                                  <DivFormatada className="space-items mt-3 mb-2 mr-4">
                                    <Row>
                                      <Col>
                                        <LancesBalanco
                                          fichaTecnica={ftUsar as FichaTecnica}
                                        />
                                      </Col>
                                    </Row>
                                  </DivFormatada>
                                )}
                              </Row>
                            </div>
                          );
                        },
                      )}
                      {/* <div className="space-items mt-3">
                        <Row>
                          <Col>
                            <LabelItem>
                              Proposta Fockink ao cliente:&nbsp;
                            </LabelItem>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <SpanTitulo>{textoProduto}</SpanTitulo>
                          </Col>
                        </Row>
                        <Row>
                          {fichaTecnica && (
                            <DivFormatada className="space-items mt-3 mb-2 mr-4">
                              <Row>
                                <Col>
                                  <LancesBalanco
                                    fichaTecnica={fichaTecnica as FichaTecnica}
                                  />
                                </Col>
                              </Row>
                            </DivFormatada>
                          )}
                        </Row>
                      </div> */}
                      <div className="space-items mt-3">
                        <Row>
                          <Col sm="1">
                            <LabelItem>Valor:&nbsp;</LabelItem>
                          </Col>
                          <Col sm="4">
                            <LabelItem>
                              (Desconto&nbsp;{propostaVersao.desconto}%)
                            </LabelItem>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <SpanTitulo>
                              {formataMoeda(propostaVersao.valorFinal)}
                            </SpanTitulo>
                          </Col>
                        </Row>
                      </div>
                      <div className="space-items mt-3">
                        <Row>
                          <Col>
                            <LabelItem>
                              Comissão Final(Calculada + Ajuste Comissão):&nbsp;
                            </LabelItem>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <SpanTitulo>
                              {!propostaVersao.proposta.usuario.isIsentoComissao
                                ? (propostaVersao.PropostaVersaoPrecificacao
                                    .percentualComissao ?? 0) +
                                  (propostaVersao.PropostaVersaoPrecificacao
                                    .percentualAjusteComissao ?? 0)
                                : '0'}
                              %
                            </SpanTitulo>
                          </Col>
                        </Row>
                      </div>
                      <div className="space-items mt-3">
                        <Row>
                          <Col>
                            <LabelItem>Cronograma:&nbsp;</LabelItem>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <SpanTitulo>
                              {ataBriefingEditing.cronograma}
                            </SpanTitulo>
                          </Col>
                        </Row>
                      </div>
                      <div className="space-items mt-3">
                        <Row>
                          <Col>
                            <ImpressaoPagamento
                              propostaVersaoId={propostaVersao.id}
                              mostrarPercentual={false}
                            />
                          </Col>
                        </Row>
                      </div>
                      {acessoLimitadoAta === false && (
                        <div className="mt-3">
                          <Row>
                            <Col>
                              <LabelItem>Dre:&nbsp;</LabelItem>
                            </Col>
                          </Row>

                          <Row>
                            <Col>
                              <Resultados
                                propostaVersao={propostaVersao}
                                apenasSintetica
                              />
                            </Col>
                          </Row>
                        </div>
                      )}
                      {propostaVersao.status.id !== 3 ? (
                        <DivSub>
                          <Row>
                            <Col>
                              <ReactQuill
                                value={texto}
                                style={{ overflow: 'scroll', height: '400px' }}
                                onChange={setTexto}
                                placeholder="Editar conteúdo..."
                                theme="snow"
                                modules={{
                                  blotFormatter: {
                                    overlay: {
                                      style: { border: '2px solid red' },
                                    },
                                    align: {
                                      aligner: {
                                        applyStyle: false,
                                      },
                                      toolbar: {
                                        mainClassName:
                                          'blot-formatter__toolbar',
                                        mainStyle: {
                                          display: 'none',
                                        },
                                        buttonStyle: {
                                          display: 'none',
                                        },
                                        svgStyle: { display: 'none' },
                                      },
                                    },
                                    toolbar: {
                                      // whether or not users can deselect an alignment. it's up to you to set the initial alignment
                                      allowDeselect: false,
                                      addButtonSelectStyle: false,
                                    },
                                  },
                                  toolbar: toolbarOptions,
                                }}
                              />
                            </Col>
                          </Row>
                        </DivSub>
                      ) : (
                        <div dangerouslySetInnerHTML={createMarkup('')} />
                      )}

                      <div className="space-items mt-2 mb-2 mr-4">
                        <Row>
                          <Col>
                            <Button
                              className="my-4"
                              color="primary"
                              type="button"
                              hidden={propostaVersao.status.id === 3}
                              disabled={
                                isSaving || propostaVersao.status.id === 3
                              }
                              onClick={handleSave}
                            >
                              {isSaving ? 'Salvando...' : 'Salvar'}
                            </Button>
                          </Col>
                        </Row>
                      </div>
                      {/* <FloatingButton
                        className="hide-on-print"
                        disabled={isLoadingContent}
                        onClick={handleImprimeAta}
                      >
                        <FaPrint />
                      </FloatingButton> */}
                    </ConteudoDocumentoAta>
                  </Geral>
                </CardBody>
              </Col>
            </Row>
          </Form>
        </Card>
      </Container>
    </>
  );
};

export default AtaProposta;
